import React from 'react'

const STATUS_CONFIG = {
  pending_w9: {
    label: 'Pending W9',
    className: 'bg-warning text-dark',
    icon: 'fa-file-text'
  },
  pending_contract: {
    label: 'Pending Contract',
    className: 'bg-info text-white',
    icon: 'fa-file-signature'
  },
  pending_signature: {
    label: 'Pending Signature',
    className: 'bg-primary text-white',
    icon: 'fa-pen'
  },
  completed: {
    label: 'Completed',
    className: 'bg-success text-white',
    icon: 'fa-check-circle'
  },
  expired: {
    label: 'Expired',
    className: 'bg-danger text-white',
    icon: 'fa-clock'
  }
}

const DocumentationStatusBadge = ({ status, showIcon = true, size = 'md' }) => {
  const config = STATUS_CONFIG[status] || {
    label: status || 'Unknown',
    className: 'bg-secondary text-white',
    icon: 'fa-question-circle'
  }

  const sizeClass = size === 'sm' ? 'badge-sm' : size === 'lg' ? 'badge-lg' : ''

  return (
    <span className={`badge ${config.className} ${sizeClass}`}>
      {showIcon && <i className={`fa ${config.icon} me-1`} aria-hidden="true"></i>}
      {config.label}
    </span>
  )
}

export default DocumentationStatusBadge
